import React, { useEffect, useState } from 'react'
import { CatalogComponent } from '../components/CatalogComponent'
import { getCatalogs } from '../hooks/gets'
import { connect } from 'react-redux';
import { DobleGuion } from '../components/DobleGuion'
import * as _ from 'lodash'
import moment from 'moment'
import './CatalogosPage.scss'
import { scrollBodyTop } from '../hooks/scrollPosition';
import { privilegeUser } from '../hooks/user';

const CatalogosPage = (props) => {
    const [catalogs, setCatalogs] = useState([])

    useEffect(() => {
        scrollBodyTop()
        handleclickGetCatalogs()
    }, [])

    useEffect(() => {
        handleclickGetCatalogs()
    }, [props.userActive])

    const handleclickGetCatalogs = async () => {
        getCatalogs().then(async res => {
            if (await privilegeUser()) {
                setCatalogs(res.data)
            } else {
                setCatalogs(_.filter(res.data, { 'catalogClient': false }))
            }
        }).catch(err => {
            console.log('err', err)
        })
    }

    return (
        <div className="catalogs-page-container">
            <div className="header">
                <img className="movil" src="../static/img/header-catalogos-m.jpg" alt="" />
                <img className="tablet" src="../static/img/header-catalogos-t.jpg" alt="" />
                <img className="escritorio" src="../static/img/header-catalogos.jpg" alt="" />
            </div>
            <div className="title">
                <p>Catálogos</p>
                <DobleGuion />
            </div>
            <div className="catalogs">
                {catalogs.map((catalog, index) => {
                    return (
                        <CatalogComponent catalog={catalog} key={index} />
                    )
                })}
            </div>
        </div>
    )
}

const mapStateToProps = state => state

export default connect(mapStateToProps, null)(CatalogosPage)